import React from 'react';
import { Check, Star, X, ArrowRight } from 'lucide-react';
export const Navbar = () => <nav className="bg-brand-bg border-b border-brand-borderSuave shadow-[0_1px_8px_rgba(15,30,58,0.04)] h-[44px] flex items-center px-5 sticky top-0 z-[100]" data-id="element-1">
    <div className="w-full flex justify-center items-center" data-id="element-2">
      <span className="font-playfair font-bold text-[13px] text-brand-text tracking-[1.5px] uppercase" data-id="element-3">
        CHERUB AGENCY™
      </span>
    </div>
  </nav>;
export const Hero = () => <section className="bg-brand-bg pt-8 md:pt-12 pb-10 md:pb-14 px-5 md:px-10 flex flex-col items-center text-center" data-id="element-4">
    <div className="max-w-[820px] w-full flex flex-col items-center" data-id="element-5">
      <div className="bg-brand-paleBlue border border-brand-accent/30 text-brand-accent font-inter font-bold text-[10px] tracking-[1.2px] px-[14px] py-[4px] rounded-[20px] mb-[12px] inline-block uppercase" data-id="element-6">
        SISTEMA N°1 PARA PADRES PRIMERIZOS EN ESPAÑA
      </div>

      <h1 className="font-playfair font-bold text-[34px] md:text-[52px] text-brand-text leading-[1.12] tracking-[-0.5px]" data-id="element-7">
        Cómo Entender a Tu Bebé
      </h1>

      <h2 className="font-playfair italic text-[22px] text-brand-accentPremium font-[500]" data-id="element-8">
        Manual paso a paso para padres primerizos
      </h2>

      <div className="w-full max-w-[600px] my-0" data-id="element-9">
        <img src="https://cdn.magicpatterns.com/uploads/mimkSu4WfRuMcqGM7KfK63/17f95cff-c426-4d98-84ce-1917901eb530.png" alt="Cómo Entender a Tu Bebé - Sistema Completo" className="w-full h-auto" data-id="element-10" />
      </div>

      <p className="font-inter text-brand-textSec max-w-[600px] mb-[32px] font-[500] text-[14px]" data-id="element-11">
        El sistema más completo para entender a tu bebé, recuperar el control y
        disfrutar de la crianza sin sentirte perdido.
      </p>

      <div className="flex flex-nowrap justify-center gap-[4px] mb-[32px] w-full px-1" data-id="element-12">
        {['100% PDF', 'Acceso 5 min', 'Garantía 7d', 'Pago seguro'].map((badge, i) => <div key={i} className="bg-brand-bgAlt border border-brand-borderMedio rounded-[5px] px-[5px] py-[3px] flex items-center gap-1" data-id="element-13">
              <Check className="w-2.5 h-2.5 text-brand-accentExtra shrink-0" data-id="element-14" />
              <span className="font-inter font-semibold text-[9px] md:text-[11px] text-brand-text whitespace-nowrap" data-id="element-15">
                {badge}
              </span>
            </div>)}
      </div>

      <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    })} className="bg-brand-accent hover:bg-brand-accentHover text-white font-inter font-bold text-[18px] px-[56px] py-[20px] rounded-[10px] shadow-[0_8px_24px_rgba(74,114,184,0.38)] hover:shadow-[0_10px_30px_rgba(74,114,184,0.48)] transition-all duration-250 transform hover:-translate-y-[2px] w-full md:w-fit" data-id="element-16">
        → VER LA OFERTA COMPLETA
      </button>
    </div>
  </section>;
export const Metrics = () => <section className="bg-brand-dark py-[32px] px-4" data-id="element-17">
    <div className="max-w-[1200px] mx-auto grid grid-cols-2 md:grid-cols-4 divide-x-0 md:divide-x divide-white/15 gap-y-8 md:gap-y-0" data-id="element-18">
      {[{
      value: '+200',
      label: 'familias'
    }, {
      value: '6',
      label: 'Tomos'
    }, {
      value: '6',
      label: 'Bonos'
    }, {
      value: '4.9/5',
      label: 'Valoración',
      isStars: true
    }].map((metric, i) => <div key={i} className="flex flex-col items-center justify-center text-center px-4" data-id="element-19">
          <div className="flex flex-col items-center" data-id="element-20">
            {metric.isStars && <div className="flex gap-1 mb-1" data-id="element-21">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-[18px] h-[18px] fill-brand-accentPremium text-brand-accentPremium" data-id="element-22" />)}
              </div>}
            <div className="font-playfair font-bold text-[48px] text-white leading-[1]" data-id="element-23">
              {metric.value}
            </div>
          </div>
          <div className="font-inter text-[14px] text-white/65 mt-[6px]" data-id="element-24">
            {metric.label}
          </div>
        </div>)}
    </div>
  </section>;
const testimonials1 = [{
  quote: 'Llevaba semanas sin dormir y sin entender por qué mi bebé lloraba tanto. El Tomo 2 me explicó exactamente qué le pasaba y qué hacer. Por fin pude ayudarle de verdad.',
  author: 'Ana M.',
  city: 'Madrid',
  initial: 'A'
}, {
  quote: 'Lo que más me sorprendió es la claridad con la que explica el desarrollo del bebé mes a mes. Dejé de preocuparme por todo porque por fin entendía qué era normal y qué no.',
  author: 'Carlos R.',
  city: 'Barcelona',
  initial: 'C'
}, {
  quote: 'Habíamos leído de todo y nada nos daba un sistema claro. Este megapack tiene todo organizado. Sabemos qué leer según el problema que tengamos ese día. Ha cambiado nuestra forma de vivir la crianza.',
  author: 'Sara y Pablo',
  city: 'Valencia',
  initial: 'S'
}];
export const Testimonials1 = () => <section className="bg-brand-bgAlt py-[64px] px-5 md:px-10" data-id="element-25">
    <div className="max-w-[1100px] mx-auto" data-id="element-26">
      <div className="flex flex-col items-center mb-[40px]" data-id="element-27">
        <h2 className="font-playfair font-bold text-[36px] text-brand-text text-center mb-[10px]" data-id="element-28">
          Padres que ya lo tienen
        </h2>
        <div className="w-[64px] h-[3px] bg-brand-accentPremium rounded-[2px]" data-id="element-29"></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[24px]" data-id="element-30">
        {testimonials1.map((t, i) => <div key={i} className="bg-white rounded-[14px] p-[32px] shadow-[0_4px_20px_rgba(15,30,58,0.07)] border border-brand-borderDorado border-t-[3px] border-t-brand-accentPremium relative transition-all duration-250 hover:shadow-[0_8px_28px_rgba(15,30,58,0.12)] hover:-translate-y-[3px]" data-id="element-31">
            <div className="flex gap-1 mb-[16px]" data-id="element-32">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-[16px] h-[16px] fill-brand-accentPremium text-brand-accentPremium" data-id="element-33" />)}
            </div>
            <div className="font-playfair font-bold text-[80px] text-brand-accent opacity-10 absolute top-[20px] left-[24px] leading-none pointer-events-none z-0" data-id="element-34">
              "
            </div>
            <p className="font-inter text-[16px] text-brand-text leading-[1.72] mb-[24px] relative z-10" data-id="element-35">
              {t.quote}
            </p>
            <div className="h-[1px] bg-brand-borderDorado mb-[20px]" data-id="element-36" />
            <div className="flex items-center gap-[14px]" data-id="element-37">
              <div className="w-[46px] h-[46px] rounded-full bg-brand-dark text-white font-inter font-bold text-[18px] flex items-center justify-center shrink-0" data-id="element-38">
                {t.initial}
              </div>
              <div data-id="element-39">
                <div className="font-inter font-semibold text-[15px] text-brand-text" data-id="element-40">
                  {t.author}
                </div>
                <div className="font-inter text-[13px] text-brand-textSec mt-[2px]" data-id="element-41">
                  {t.city}
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>
  </section>;
const painPoints = ['Llevas noches sin dormir más de dos horas seguidas y ya no sabes cómo vas a aguantar un día más.', 'Tu bebé llora y no sabes qué necesita. Lo has intentado todo y nada funciona y eso te genera una angustia que no sabes cómo gestionar.', 'Te preguntas si lo que hace tu bebé es normal para su edad o si deberías preocuparte por algo.', 'Sientes que los demás padres tienen más claro lo que hacen y tú estás improvisando constantemente.', 'La relación con tu pareja está tensa porque los dos estáis agotados y ya no os comunicáis como antes.', 'Tienes miedo de no saber qué hacer si algo va mal y esa incertidumbre te acompaña a todas horas.', 'Sabes que estos meses son importantes pero el agotamiento no te deja disfrutarlos como querrías.', 'Echas de menos sentirte tú mismo. Sentirte persona además de padre o madre.'];
export const PainPoints = () => <section className="bg-brand-bg py-[64px] px-5 md:px-10" data-id="element-42">
    <div className="max-w-[760px] mx-auto" data-id="element-43">
      <h2 className="font-playfair font-bold text-[40px] text-brand-text text-center mb-[14px] leading-[1.18]" data-id="element-44">
        ¿Cuántas noches más vas a terminar así?
      </h2>
      <h3 className="font-playfair italic text-[20px] text-brand-accent text-center mb-[12px]" data-id="element-45">
        Sabemos exactamente dónde estás.
      </h3>
      <p className="font-inter text-[16px] text-brand-textSec text-center leading-[1.7] mb-[32px]" data-id="element-46">
        No es tu culpa. Nadie te enseña a descifrar el lenguaje de un recién
        nacido.
      </p>

      <div className="max-w-[680px] mx-auto flex flex-col gap-[10px]" data-id="element-47">
        {painPoints.map((point, i) => <div key={i} className="bg-white flex items-start border-l-[4px] border-brand-accentWarm rounded-r-[12px] px-[24px] py-[18px] shadow-[0_2px_10px_rgba(15,30,58,0.05)] gap-[16px]" data-id="element-48">
            <X className="w-[18px] h-[18px] text-brand-accentWarm shrink-0 mt-[2px] font-bold" strokeWidth={3} data-id="element-49" />
            <p className="font-inter text-[17px] text-brand-text leading-[1.6]" data-id="element-50">
              {point}
            </p>
          </div>)}
      </div>

      <div className="flex justify-center my-[32px] text-[24px] text-brand-accentPremium" data-id="element-51">
        ✦
      </div>

      <div className="bg-brand-paleBlue rounded-r-[14px] p-[24px] md:px-[32px] border-l-[5px] border-brand-accent mt-[4px]" data-id="element-52">
        <h4 className="font-playfair font-bold text-[26px] text-brand-text leading-[1.4]" data-id="element-53">
          ¿Y si a partir de hoy tuvieras un sistema claro para cada uno de esos
          momentos?
        </h4>
      </div>
    </div>
  </section>;